import { FocalPointPicker } from "@/admin/FocalPointPicker";
import { LABEL_CLASS } from "./shared";

// Hero/banner image picker (choose from gallery) plus desktop/mobile focal point pickers.
// Only shown for existing products whose category supports a hero field.
export const HeroPickerSection = ({ isNew, config, form, heroPickerGallery, handleSetHero, handleSetHeroFocal, handleSetHeroPosition }) => {
  if (isNew || !config.hasHeroField) return null;
  return (
    <>
      <div>
        <span className={LABEL_CLASS}>Hero / Banner Image — the large background image at the top of this product's page (independent of gallery order/thumbnail)</span>
        <div className="mt-2 flex flex-wrap gap-3">
          {heroPickerGallery.map((g, i) => (
            <button
              key={g.src}
              type="button"
              data-testid={`admin-hero-picker-${i}`}
              onClick={() => handleSetHero(g.src)}
              title={form.hero === g.src ? "Current hero image" : "Set as hero image"}
              className={`relative w-24 h-24 overflow-hidden border-2 transition-colors ${form.hero === g.src ? "border-[var(--brand-primary)]" : "border-[var(--border-default)] hover:border-white/40"}`}
            >
              <img src={g.src} alt="" className="w-full h-full object-cover" />
              {form.hero === g.src && (
                <span className="absolute inset-x-0 bottom-0 bg-[var(--brand-primary)] text-black text-[9px] font-mono uppercase tracking-wider text-center py-0.5">Hero</span>
              )}
            </button>
          ))}
        </div>
      </div>

      {(form.hero || form.thumb) && (
        <div className="space-y-6">
          <div>
            <span className={LABEL_CLASS}>Desktop Focal Point — where the hero image centers on desktop/laptop screens</span>
            <div className="mt-2">
              <FocalPointPicker
                imageSrc={form.hero || form.thumb}
                value={form.heroPosition}
                onChange={handleSetHeroPosition}
                instructionText="Click the image to set the desktop focal point"
                previewLabel="Desktop preview"
                previewAspectClass="aspect-video"
                previewWidthClass="w-48"
                testIdPrefix="admin-focal-point-desktop"
              />
            </div>
          </div>
          <div>
            <span className={LABEL_CLASS}>Mobile Focal Point — where the hero image centers on phone screens (desktop crop is unaffected)</span>
            <div className="mt-2">
              <FocalPointPicker
                imageSrc={form.hero || form.thumb}
                value={form.heroFocalMobile}
                onChange={handleSetHeroFocal}
                testIdPrefix="admin-focal-point-mobile"
              />
            </div>
          </div>
        </div>
      )}
    </>
  );
};
